import ActionTypes from './types';
export function setDonations(donations) {
    return {
        type: ActionTypes.SET_DONATIONS,
        payload: {
            donations
        },
    };
}
